import React from 'react';
import PropTypes from 'prop-types';

export default function RequestMoreInformationNotes({ lead }) {
  if (lead.requestMoreInformationNotes.length === 0) return null;

  return (
    <div className="form-group" name="lead-pi-request-more-info-notes">
      <label className="form-control">Request More Information (From Plugin)</label>
      <div className="table-container">
        <table>
          <tbody>
            {lead.requestMoreInformationNotes.map((note, index) => (
              <tr key={index}>
                <td>{note.createdAt}</td>
                <td>{note.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

RequestMoreInformationNotes.propTypes = {
  lead: PropTypes.shape({
    requestMoreInformationNotes: PropTypes.arrayOf(PropTypes.shape({
      createdAt: PropTypes.string,
      message: PropTypes.string
    })).isRequired
  }).isRequired
};
